import React, {Fragment} from 'react';
import {useSelector} from "react-redux";

const IframeBlock = ({key, url, width ='', height=''}) => {
    const documentData = useSelector(state => state.main.currentDocument.documentData);

    return (
        <div className="card mb-2 mb-lg-4" key={key}>
            <div className="card-body body-small">
                <div className="row no-gutters pt-3 pb-3 pb-lg-2">
                    <div className="col-12">
                        <iframe src={url}  style={{border: "none"}} width={width} height={height}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IframeBlock;